const APP_URL_BASE = "https://gnssaugplanner.trimble.com/app";
const TID_URL_BASE = "https://id.trimble.com"
const SERVICE_URL_BASE = "https://gnssaugplanner.trimble.com/tgap"

export const env = {
    clientId: "e8b7685a-6dec-45c0-a094-3c566916c5fb",
    applicationName: "TGAP",
    authCodeUrl: `${TID_URL_BASE}/oauth/authorize`,
    accessTokenUrl: `${TID_URL_BASE}/oauth/token`,
    logoutUrl: `${TID_URL_BASE}/oauth/logout`,
    redirectUrl: `${APP_URL_BASE}/auth/tid-redirect`,
    tenantDomain: "Trimble.com",
    applicationHomeUrl: `${APP_URL_BASE}`,
    authUrl: `${SERVICE_URL_BASE}/api/auth/init`,
    registerPath: "/app/sign-out",
    redirectPath: "/app/auth/tid-redirect"
}